import ButtonCta from '@components/atoms/button-cta'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import { useTheme } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import { useMemo } from 'react'
import useStyles from './event-cta-box.styles'

const EventCtaBox = (props) => {
  const {
    headline,
    summary,
    ctaText,
    reference,
    image,
    className,
    externalLink,
    secondaryCtaText,
    secondaryExternalLink,
    secondaryReference,
  } = props
  const theme = useTheme()
  const backgroundStyles = useMemo(() => {
    if (image && image.url) {
      return {
        backgroundImage: `url(${image.url})`,
        backgroundColor: theme.palette.opaque.blue,
        backgroundBlendMode: 'multiply',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }
    }
    return {
      backgroundColor: theme.palette.secondary.dark,
    }
  }, [image])
  const styles = useStyles({ backgroundStyles })

  return (
    <div className={`${styles.root} ${className}`}>
      <Typography variant="h4" className={styles.heading}>{headline}</Typography>
      <Typography variant="body2" className={styles.body}>{summary}</Typography>
      <Box className={styles.ctaContainer}>
        {ctaText && (
          <ButtonCta
            color="primary"
            variant="outlined"
            reference={reference}
            externalLink={externalLink}
            dataAttrs={{ 'aria-label': `${ctaText} about ${headline}` }}
          >{ctaText}
          </ButtonCta>
        )}
        {secondaryCtaText && (
          <ButtonCta
            color="primary"
            variant="outlined"
            reference={secondaryReference}
            externalLink={secondaryExternalLink}
            className={styles.secondaryCta}
            dataAttrs={{ 'aria-label': `${secondaryCtaText} about ${headline}` }}
          >{secondaryCtaText}
          </ButtonCta>
        )}
      </Box>
    </div>
  )
}

EventCtaBox.propTypes = {
  headline: PropTypes.string,
  summary: PropTypes.string,
  ctaText: PropTypes.string,
  image: PropTypes.shape({
    url: PropTypes.string,
  }),
  className: PropTypes.string,
  externalLink: PropTypes.string,
  reference: PropTypes.object,
  secondaryCtaText: PropTypes.string,
  secondaryExternalLink: PropTypes.string,
  secondaryReference: PropTypes.object,
}

EventCtaBox.defaultProps = {}

export default EventCtaBox
